import { Component, OnInit } from '@angular/core';
import {AlertNoticeLevels, EntityAlertType, EntityAlertTypes} from '../../models/IAlertInfo.interface';
import {AlertInfo} from '../../models/AlertInfo.class';
import {IUserInfo} from '../../../users/models/userInfo.interface';
import {EcaConfirmProcessService} from '../../../shared/services/eca-confirm-process.service';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {ExportExcelService} from '../../../common/services/export-excel.service';
import {DatePipe} from '@angular/common';
import {AlertsService} from '../../services/alerts.service';
import {OurUserService} from '../../../users/services/user.service';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {IOperativeAlertSummaryInfo} from '../../models/OperativeAlertSummaryInfo';
import {ListDataService} from '../../../services/list-data.service';
import {DegreeOfSupervisionString, RiskMatrixLevel} from '../../../message-models/risk-matrix-level.enum';
import {Router} from '@angular/router';
import {HelpConsts} from '../../../help/models/help-consts';
import {HelpModalService} from '../../../help/services/help-modal.service';

@Component({
  selector: 'app-supervision-alerts-page',
  templateUrl: './supervision-alerts-page.component.html',
  styleUrls: ['./supervision-alerts-page.component.scss']
})
export class SupervisionAlertsPageComponent implements OnInit {

  entityAlertType = EntityAlertType;
  loadingAlerts: boolean;
  alertInfos: AlertInfo[];
  columns: any;
  loggedInUser: IUserInfo;
  alertsLoading = true;
  alertsFilter = {includeRisks: false, showOnlyRisks: false};
  showFilters = true;
  alertTypes = EntityAlertTypes;
  alertNoticeLevels = AlertNoticeLevels;
  supervisionAlerts: IOperativeAlertSummaryInfo[]=[];
  DegreeOfSupervisionString: typeof DegreeOfSupervisionString = DegreeOfSupervisionString;
  constructor(private confirmProcessService: EcaConfirmProcessService,
              private ecaBreadcrumbService: EcaBreadcrumbService,
              private exportExcelService: ExportExcelService,
              private datePipe: DatePipe,
              private helpService: HelpModalService,
              private router: Router,
              private listDataService: ListDataService,
              private alertsService: AlertsService, private userService: OurUserService) {

  }
  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.initialiseColumnDataTableColumns();
    const alertBreadcrumbs = new Array<IBreadcrumb>();
    alertBreadcrumbs.push({label: 'Supervision Alerts', iconName: 'exclamation-triangle'} as IBreadcrumb);
    this.userService.getLoggedInUser().subscribe(loggedInUser => {
      this.loggedInUser = loggedInUser;
      this.getSupervisionAlertsForCompany();
    });
    this.ecaBreadcrumbService.breadCrumbs.next(alertBreadcrumbs);
  }
  initialiseColumnDataTableColumns(){
    this.columns = null;
    this.columns = [
      { field: 'operativeFullName', header: 'Name', type: 'text' },
      { field: 'referenceNumbers', header: 'Reference Nos', type: 'text' },
      { field: 'currentJobTitle', header: 'Job Role', type: 'text' },
      { field: 'currentRisk', header: 'Work Risk', type: 'text' },
      { field: 'currentJobLevel', header: 'Job Level', type: 'text' },
      { field: 'riskMatrixLevel', header: 'Supervision', type: 'enum' },
      { field: 'startedOn', header: 'Started On', type: 'date' },
    ];
  }

  getSupervisionAlertsForCompany() {
    this.alertsService.getSupervisionAlertsForCompany(this.loggedInUser?.companyId).subscribe(supervisionAlerts => {
      this.supervisionAlerts = supervisionAlerts;
      this.alertsLoading = false;
    })
  }

  openAlertsLoadingHelp() {
    this.helpService.openHelpModal(HelpConsts.SupervisionAlertsHelp);

  }

  exportToExcel() {
    const alertInfosToExport = [];
    this.supervisionAlerts.forEach( alertInfo => {
      const tempObject = {
        operativeFullName: alertInfo.operativeFullName,
        referenceNumbers: alertInfo.referenceNumbers,
        currentJobTitle: alertInfo.currentJobTitle,
        currentRisk: alertInfo.currentRisk,
        currentJobLevel: alertInfo.currentJobLevel,
        riskMatrixLevel: this.DegreeOfSupervisionString[alertInfo?.riskMatrixLevel],
        startedOn: this.datePipe.transform(alertInfo.startedOn, 'dd/MM/yyyy'),
      };
      alertInfosToExport.push(tempObject);
    });
    const exportColumns = [
      { field: 'operativeFullName', header: 'Name', type: 'text' },
      { field: 'referenceNumbers', header: 'Reference Nos', type: 'text' },
      { field: 'currentJobTitle', header: 'Job Role', type: 'text' },
      { field: 'currentRisk', header: 'Work Risk', type: 'text' },
      { field: 'currentJobLevel', header: 'Job Level', type: 'text' },
      { field: 'riskMatrixLevel', header: 'Supervision', type: 'enum' },
      { field: 'startedOn', header: 'Started On', type: 'date' },
    ];
    this.exportExcelService.exportToExcel(alertInfosToExport, exportColumns, 'Operatives in High Supervision - Alerts');


  }
  viewOperative(iOperativeAlertSummaryInfo: IOperativeAlertSummaryInfo) {
    this.router.navigateByUrl("/operative/" + iOperativeAlertSummaryInfo.operativeId);
  }

}
